import { getController, postController } from '@/controllers/request';
import { MODULE, ACTION, EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';

export default {
  namespaced: true,
  state: {
    metadata: {},
    fields: {},
    currentVacancyRespond: null,
    respondData: [],
    responds_stage_condidates_count: null,
    respond_subpanel_display: null,
    allResponds: [],
    loading: false,
    respondOpening: false,
    lastResponsePage: false,
    tableTitleParams: null
  },
  mutations: {
    setFields(state, data) {
      state.fields = { ...data };
    },
    setRespondSubpanelDisplay(state, data) {
      state.respond_subpanel_display = data;
    },
    setRespondData(state, data = []) {
      state.respondData = [...data];
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setRespondsCount(state, count) {
      state.responds_stage_condidates_count = count;
    },
    setAllResponds(state, data) {
      state.allResponds.push(...data);
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setMetadata(state, metadata) {
      state.metadata = metadata;
    }
  },
  actions: {
    async getMetadata({ commit }, id) {
      commit('setLoading', true);
      try {
        commit('setParam', {
          name: 'respondOpening',
          val: true
        });
        const response = await getController({
          params: {
            module: MODULE.CANDIDATE_RESPONDS,
            action: 'get_DetailView',
            record: id
          }
        });
        commit('setParam', {
          name: 'respondOpening',
          val: false
        });
        commit('setMetadata', response.data);
        if (response.data?.bean?.id.value) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async loadResponds({ commit }, { vacancyId, showNewResponds = false }) {
      // Поправить метод получения карточки отклика
      if (!vacancyId) {
        commit(
          'selectionPopup/setBaseParams',
          {
            module: MODULE.CANDIDATES_MODULE,
            action: ACTION.LIST_VIEW,
            jsqon_return: 1,
            to_pdf: true,
            query: true
          },
          { root: true }
        );
      }

      let params = {
        module: MODULE.CANDIDATE_RESPONDS,
        displayMode: 'spa',
        action: ACTION.LIST_VIEW,
        HRPAC_CANDIDATES2_HRPAC_CANDIDATES_offset: 0,
        query: true
      };

      if (vacancyId) {
        params['vacancy_id'] = vacancyId;
      }

      if (showNewResponds) {
        params['show_only_new_advanced'] = true;
      }

      try {
        const request = await getController({ params });

        commit(
          'common/setTableData',
          {
            module: 'vacancy_responds',
            columns: request.data.data.data.data.title,
            rows: request.data.data.data.data.rows
          },
          { root: true }
        );

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
          root: true
        });

        commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', request.data.custom_search, {
          root: true
        });

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !request.data?.custom_search?.sortable?.default || false
          },
          { root: true }
        );

        if (!vacancyId) commit('setCandidateListData', request.data);

        if (request.data.data.data.data?.title_params) {
          commit('setParam', {
            name: 'tableTitleParams',
            val: request.data.data.data.data.title_params
          });
        }

        eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);
      } catch (error) {
        console.error(error);
      }
    },
    showAuthForm({ rootState }) {
      rootState.publicator.importData = { work_site: 'hh' };
      rootState.common.visible_dialog.publicator_auth_dialog = true;
    },
    async getRespondsPage({ state, commit, rootState }, { id, page }) {
      if (state.lastResponsePage) return;
      try {
        commit('setLoading', true);
        const data = await getController({
          params: {
            module: MODULE.CANDIDATE_RESPONDS,
            action: 'getRespondsListByVacancy',
            to_pdf: true,
            vacancy_id: id,
            count: rootState.common.config.maxEntriesLimit,
            iteration: page
          }
        });
        const { respond_subpanel_display, responds } = data.data;
        state.lastResponsePage =
          responds.length < rootState.common.config.maxEntriesLimit;
        if (responds) commit('setAllResponds', responds);
        commit('setRespondSubpanelDisplay', respond_subpanel_display);
        commit('setLoading', false);
      } catch (err) {
        console.log(err);
      }
    },
    async getFields({ state }, { fields }) {
      // экшн получения нужных полей по кандидатам
      try {
        const formData = new FormData();
        formData.append('module', MODULE.CANDIDATE_RESPONDS);
        formData.append('action', ACTION.GET_MODULE_FIELDS);
        formData.append('id', state.fields.id.value);
        formData.append('to_pdf', true);

        if (fields && Array.isArray(fields)) {
          fields.forEach(name => formData.append('fields[]', name));
        }

        const request = await postController({ options: formData });
        return await request.data;
      } catch (error) {
        console.error(error);
      }
    },
    async acceptRespond({ dispatch }, id) {
      try {
        const options = new FormData();

        options.append('module', MODULE.CANDIDATE_RESPONDS);
        options.append('action', 'convertResponseIntoCandidate');
        options.append('response_id', id);
        options.append('to_pdf', true);

        const response = await postController({ options });

        if (response.data.error && response.data.code == 403) {
          dispatch('showAuthForm');
        } else location.reload();
      } catch (err) {
        console.error(err);
        dispatch('showAuthForm');
      }
    },
    async rejectRespond({ dispatch }, id) {
      try {
        const options = new FormData();

        options.append('module', MODULE.CANDIDATE_RESPONDS);
        options.append('action', 'rejectResponse');
        options.append('response_id', id);
        options.append('to_pdf', true);

        const response = await postController({ options });

        if (response.data.error && response.data.code == 403) {
          dispatch('showAuthForm');
        } else location.reload();
      } catch (err) {
        console.error(err);
        dispatch('showAuthForm');
      }
    }
  }
};
